import React from 'react';
import { Check } from 'lucide-react';

const UNLIMITED_FEATURES = [
  'Unlimited staff members',
  'Unlimited branches & locations',
  'Unlimited contacts',
  'Unlimited vehicles',
  'Unlimited backoffice usage',
  'Unlimited messages',
  'Unlimited extras',
  'Unlimited support',
];

const PricingCTASection = () => (
  <section className="vipo-marquee">
    <div className="vipo-marquee__viewport">
      <div className="vipo-marquee__track">
        {[...UNLIMITED_FEATURES, ...UNLIMITED_FEATURES, ...UNLIMITED_FEATURES].map((item, i) => (
          <span key={`${item}-${i}`} className="vipo-marquee__chip">
            <Check className="vipo-marquee__check" size={20} strokeWidth={2.5} />
            {item}
          </span>
        ))}
      </div>
    </div>
  </section>
);

export default PricingCTASection;
